/* eslint-disable semi */
import { createDecorator } from 'vue-class-component';
import * as utils from './utils';
import { Cache } from '../libs';
import DecoratorConfigs from './DecoratorConfigs';

const debug = process.env.NODE_ENV === 'development';

const DECORATOR_NAME = 'BindCache';

/**
 * コンポーネントにキャッシュへのアクセッサを追加します
 *
 * コンポーネントに下記を追加します。
 * this.$_sas.$cache: キャッシュ
 */
export default function BindCache (...args) {
  if (utils.isDecoratorCall(args)) {
    createAppDecorator()(...args);
  } else {
    return createAppDecorator(...args);
  }
}

// グローバルキャッシュ
const GLOBAL_CACHE = new Cache();

function findParentComponentCache (vue) {
  if (vue.$parent) {
    if (vue.$parent.$_sas && vue.$parent.$_sas.$cache) {
      return vue.$parent.$_sas.$cache;
    } else {
      return findParentComponentCache(vue.$parent);
    }
  } else {
    if (debug) {
      console.warn('use global cache.');
    }
    return GLOBAL_CACHE;
  }
}

function createAppDecorator (decoratorOptions = {}) {
  // 設定値のマージ
  decoratorOptions = DecoratorConfigs.marge(DECORATOR_NAME, decoratorOptions);

  // 実装時の整合性チェック
  if (debug) {
    utils.validateDecoratorOptions(DECORATOR_NAME, {
      transparent: { type: 'boolean' }
    }, decoratorOptions);
  }

  return createDecorator((options, key) => {
    // 実装時の整合性チェック
    if (debug) {
      console.debug(`${DECORATOR_NAME}: @ ${key}`);

      if (key !== 'data') {
        throw new Error(`${DECORATOR_NAME}: can decorate only data().`);
      }
    }

    // オプション値取得
    const transparent = decoratorOptions.transparent || false;

    // created時の処理を追加
    const created = options.created || function () { };
    options.created = utils.injectBefore(created, function () {
      // デコレータ管理用変数初期化
      this.$_sas = this.$_sas || {};

      if (transparent) {
        // 親コンポーネントのキャッシュを参照する
        this.$_sas.$cache = findParentComponentCache(this);
      } else {
        // 自身のキャッシュを参照する
        this.$_sas.$cache = new Cache();
      }
    });

    // destroyed時の処理を追加
    const destroyed = options.destroyed || function () { };
    options.destroyed = utils.injectAfter(destroyed, function () {
      // デコレータ管理用変数破棄
      if (this.$_sas) {
        if (this.$_sas.$cache) {
          if (transparent) {
            // 親コンポーネントのキャッシュ参照時は内容をクリアしない
          } else {
            this.$_sas.$cache.destroy();
          }
          delete this.$_sas.$cache;
        }
        if (Object.keys(this.$_sas).length === 0) {
          delete this.$_sas;
        }
      }
    });
  });
}



// WEBPACK FOOTER //
// ./src/core/decorators/BindCache.js